import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PersonalCampaignAssociation {
  campaignId: number;
  campaignName: string;
  campaignCode: string;
  flux: string;
  dataType: string;
  status: string;
  origin: string;
  associatedAt: string;
  commandId?: number;
  commandRef?: string;
  /** From cost_record (acquisition for import, sale for export) */
  costContact?: number | string;
  costOrder?: number | string;
  costAllocationStatus?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EngineCampaignAssociationService {

  private readonly resourceUrl = environment.SERVER_API_URL + 'services/engine/api/campaigns';

  constructor(private http: HttpClient) {}

  getByPersonal(tenant: string, personalId: number, partner?: string): Observable<PersonalCampaignAssociation[]> {
    const url = `${this.resourceUrl}/by-personal/${personalId}`;
    let headers = new HttpHeaders().set('X-DataStoreID', tenant);
    if (partner) {
      headers = headers.set('X-PARTNER-ID', partner);
    }
    return this.http.get<PersonalCampaignAssociation[]>(url, { headers });
  }

  getByCommand(tenant: string, commandId: number, partner?: string): Observable<PersonalCampaignAssociation[]> {
    const url = `${this.resourceUrl}/by-command/${commandId}`;
    let headers = new HttpHeaders().set('X-DataStoreID', tenant);
    if (partner) {
      headers = headers.set('X-PARTNER-ID', partner);
    }
    return this.http.get<PersonalCampaignAssociation[]>(url, { headers });
  }
}

